import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from "react";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { hasConfigurationInfo, useCsValue, } from "@plansoft-configuration-renderer/framework";
import { ValueComponentContext, } from "@plansoft-configuration-renderer/layout";
import { AttributeValueContentType } from "./AttributeValueContentType";
import { VALUE_CONTENT_DEFAULTS } from "./ValueContent.defaults";
const DEFAULTS = {
    template: [
        AttributeValueContentType.TypeCode,
        AttributeValueContentType.Value,
    ],
    separator: " ",
};
const propertyFilters = {
    [AttributeValueContentType.Value]: (value) => value.value != null,
    [AttributeValueContentType.Name]: (value) => value.name != null,
    [AttributeValueContentType.Description]: (value) => value.description != null,
    [AttributeValueContentType.AttributeName]: () => true,
    [AttributeValueContentType.TypeCode]: (value) => !!value.typeCodeFragment,
    [AttributeValueContentType.ItemNo]: (value) => value.partId != null,
    [AttributeValueContentType.Price]: (value) => value.price != null,
    [AttributeValueContentType.Suggestion]: (value) => !!value.recommendationScore,
    [AttributeValueContentType.Help]: (value) => {
        var _a, _b;
        return hasConfigurationInfo((_a = value.properties) !== null && _a !== void 0 ? _a : undefined, (_b = value.attachments) !== null && _b !== void 0 ? _b : undefined);
    },
};
const propertyAccessor = {
    [AttributeValueContentType.Name]: (props) => props.nameProps,
    [AttributeValueContentType.Description]: (props) => props.descriptionProps,
    [AttributeValueContentType.Help]: (props) => props.infoProps,
    [AttributeValueContentType.AttributeName]: (props) => props.nameProps,
};
/**
 * Displays multiple values in a tightly spaced grid
 * @param props
 * @returns
 */
export function ValueContentMultiple(props) {
    const value = useCsValue();
    const components = useContext(ValueComponentContext);
    const { template = DEFAULTS.template, separator = DEFAULTS.separator, columnSpacing = 1, alignItems = "center", justifyContent = "flex-start", separatorColor, } = props;
    const contents = [];
    // iterate over all items in the template
    template
        .reduce((items, item) => {
        // remove empty items
        const filter = propertyFilters[item];
        // this detection of empty values might not work for all case, e.g. description
        if (!filter || !filter(value)) {
            return items;
        }
        return [...items, item];
    }, [])
        .forEach((item, itemIndex, nonEmptyTemplate) => {
        var _a, _b;
        if (!(item in components)) {
            return;
        }
        const Component = components[item];
        const componentProps = (_b = (_a = propertyAccessor[item]) === null || _a === void 0 ? void 0 : _a.call(propertyAccessor, props)) !== null && _b !== void 0 ? _b : (item in VALUE_CONTENT_DEFAULTS ? [item] : undefined);
        if (!Component) {
            return;
        }
        // unfortunately, component props are not supported yet
        contents.push(_jsx(Grid, { children: _jsx(Component, Object.assign({}, componentProps)) }, `item-${itemIndex}`));
        // add separator if not last item
        if (separator && itemIndex !== nonEmptyTemplate.length - 1) {
            contents.push(_jsx(Grid, { children: _jsx(Typography, { color: separatorColor, children: separator }) }, `separator-${itemIndex}`));
        }
    });
    return (_jsx(Grid, { container: true, columnSpacing: columnSpacing, sx: {
            alignItems: alignItems,
            justifyContent: justifyContent,
        }, children: _jsx(_Fragment, { children: contents }) }));
}
//# sourceMappingURL=ValueContentMultiple.js.map